import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import Main from "./Layout/Main";
import About from "./Pages/About/About";
import Contact from "./Pages/Contact/Contact";
import Home from "./Pages/Home/Home";
import ReGame from "./Pages/Project/ReGame";
import ShuterUp from "./Pages/Project/ShuterUp";
import SkillEdge from "./Pages/Project/SkillEdge";
import Projects from "./Pages/Projects/Projects";
import Skills from "./Pages/Skills/Skills";

function App() {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Main />,
            children: [
                {
                    path: "/",
                    element: <Home />,
                },
                {
                    path: "/home",
                    element: <Home />,
                },
                {
                    path: "/skills",
                    element: <Skills />,
                },
                {
                    path: "/projects",
                    element: <Projects />,
                },
                {
                    path: "/projects/regame",
                    element: <ReGame />,
                },
                {
                    path: "/projects/shuterup",
                    element: <ShuterUp />,
                },
                {
                    path: "/projects/skilledge",
                    element: <SkillEdge />,
                },
                {
                    path: "/about",
                    element: <About />,
                },
                {
                    path: "/contact",
                    element: <Contact />,
                },
            ],
        },
    ]);
    return (
        <div>
            <RouterProvider router={router}></RouterProvider>
        </div>
    );
}

export default App;
